import React, { createContext, useContext, useState } from 'react';

const AutoUpdateContext = createContext();

export const AutoUpdateProvider = ({ children }) => {
  const [isActive, setIsActive] = useState(false);

  const toggleAutoUpdate = () => {
    setIsActive((prev) => !prev);
  };

  return (
    <AutoUpdateContext.Provider value={{ isActive, toggleAutoUpdate }}>
      {children}
    </AutoUpdateContext.Provider>
  );
};

export const useAutoUpdate = () => useContext(AutoUpdateContext);
